import { Form, Row, Col, Select, Input, Radio, Alert } from "antd";
import { useState } from "react";
import { createCall } from "../../../app/orders/api";

const { TextArea } = Input;

const LLAMADA = ["Entrante", "Saliente", "Novedad"];

const FUENTES = ["Cliente", "Haceb", "Contact", "Operador"];

const PRIORIDADES = ["Baja", "Media", "Alta"];

const CAUSAS = [
  "AVERIA EN TRANSPORTE",
  "CLIENTE APLAZA",
  "CLIENTE DESISTE DE LA COMPRA",
  "CLIENTE NO CONTESTA",
  "DATOS ERRADOS",
  "DEMORA RECIBO TIENDA",
  "DIFICIL ACCESO",
  "EN RUTA",
  "ERROR FECHA PROMESA",
  "HURTO EN TRANSPORTE",
  "NADIE EN DOMICILIO",
  "NOVEDAD COORDINADORA (ALKOSTO)",
  "NOVEDAD EN CEDI (HACEB)",
  "NOVEDAD EN LA ENTREGA",
  "NOVEDAD PLATAFORMA HACEB",
  "PAROS Y/O MANIFESTACIONES",
  "PEDIDO INGRESA INCONSISTENTE",
  "PRODUCTO IMPERFECTO",
  "SIN COBERTURA (EAD)",
  "VENTA FUERA DEL CARGUE",
  "RECIBO CERRADO",
  "INFORMACION DE LA ENTREGA",	
  "INCUMPLIMIENTO EN ACTUALIZACION",
  "INCUMPLIMIENTO EN TRANSPORTE",	
  "PEDIDO CANCELADO",
  "NO CORRESPONDE A LA ZONA",
  "FALTA DE INVENTARIO",
  "EN PROGRAMACION SEGUN FRECUENCIA",
  "ENTREGA CONFIRMADA",
  "CONFIRMADA DEVOLUCION",
  "GESTION TDC"
];


export const CallForm = ({ order, products, onCreateCall, zones }) => {
  const [form] = Form.useForm();
  const [callType, setCallType] = useState(LLAMADA[0]);
  const [response, setResponse] = useState(null);
  const [isSendForm, setIsSendForm] = useState(false);
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  async function onFinish(values) {
    const callForm = { ...values, products };

    const callPayload = {
      id: order.id,
      posiciones: callForm.products.map((p) => p.id),
      tipo_llamada: callForm.tipoLlamada,
      causa: callForm.causa,
      fuente: callForm.fuente,
      persona_atendida: callForm.personaAtendida,
      detalle: callForm.detalle,
      zona: callForm.zona,
      prioridad: callForm.prioridad,
      usuario: username
    };

    await createCall(callPayload)
      .then((response) => {
        setResponse({ type: "success", message: response });
        onCreateCall({ type: "success", message: response, ...callPayload })
        setIsSendForm(true);
      })
      .catch((error) => {
        setResponse({ type: "error", message: error.response.data.result })
      });

  }

  const handleCallType = (event) => {
    const callType = event.target.value;
    setCallType(callType);
    form.setFieldValue("fuente", null);
    form.setFieldValue("zona", null);
    form.setFieldValue("prioridad", null);
  };

  const keyCallType = () => {
    if(callType === "Entrante") {
      return FUENTES.filter((f) => f === "Cliente")
    }
    if(callType === "Saliente") {
      return FUENTES.filter((f) => f !== "Cliente");
    }
    if(callType === "Novedad") {
      return FUENTES;
    }
  }

  return (
    <>
      {(isSendForm && response) && (
        <div className="success-call-alert">
          <Alert message={response.message} type={response.type} />
        </div>
      )}
     { !isSendForm && (
       <Form
       form={form}
       autoComplete="off"
       name="callForm"
       layout="vertical"
       onFinish={onFinish}
       initialValues={{
         tipoLlamada: callType,
         ordenCompra: order.ordenCompra,
         cedulaSubCliente: order.cedula,
         nombreSubCliente: order.nombre,
         telefonoPrincipal: order.telefono,
         direccion: order.direccion,
       }}
     >
       <Row className="form--first-row">
         <Col className="gutter-row">
           <Form.Item
             name="tipoLlamada"
             rules={[{ required: false, message: "requerido" }]}
             label="Tipo Llamada"
           >
             <Radio.Group
               options={LLAMADA}
               optionType="button"
               buttonStyle="solid"
               onChange={handleCallType}
             />
           </Form.Item>
         </Col>
       </Row>
       <Row className="form--first-row">
       
         <Col className="gutter-row">
           <Form.Item
             name="causa"
             rules={[{ required: true, message: "requerido" }]}
             label="Causa"
           >
             <Select
               showSearch
               size="medium"
               placeholder="Seleccione"
               filterSort={(optionA, optionB) =>
                 (optionA?.label ?? "")
                   .toLowerCase()
                   .localeCompare((optionB?.label ?? "").toLowerCase())
               }
               options={[
                 ...CAUSAS.map((p) => {
                   return {
                     value: `${p}`,
                     label: `${p}`,
                   };
                 }),
               ]}
             />
           </Form.Item>
         </Col>
         <Col className="gutter-row">
           <Form.Item
             name="fuente"
             rules={[{ required: true, message: "requerido" }]}
             label="Fuente"
           >
             <Select
               showSearch
               size="medium"
               placeholder="Seleccione"
               options={[
                 ...keyCallType().map((p) => {
                   return {
                     value: `${p}`,
                     label: `${p}`,
                   };
                 }),
               ]}
             />
           </Form.Item>
         </Col>
         <Col className="gutter-row">
           <Form.Item
             name="ordenCompra"
             rules={[{ required: false, message: "requerido" }]}
             label="Orden Compra"
           >
             <Input type="text" size="medium" disabled={true} />
           </Form.Item>
         </Col>

         <Col className="gutter-row">
           <Form.Item
             name="personaAtendida"
             rules={[{ required: true, message: "requerido" }]}
             label="Persona Atendida"
           >
             <Input type="text" size="medium" />
           </Form.Item>
         </Col>
         <Col className="gutter-row">
           <Form.Item
             name="zona"
             rules={[{ required: callType !== 'Novedad' ? false : true, message: "requerido" }]}
             label="Zona Responsable"
           >
             <Select
               showSearch
               size="medium"
               placeholder="Seleccione"
               filterSort={(optionA, optionB) =>
                 (optionA?.label ?? "")
                   .toLowerCase()
                   .localeCompare((optionB?.label ?? "").toLowerCase())
               }
               options={[
                 ...zones.map((p) => {
                   return {
                     value: `${p.nombre}`,
                     label: `${p.nombre}`,
                   };
                 }),
               ]}
               disabled={callType !== 'Novedad'}
             />
           </Form.Item>
         </Col>
         <Col className="gutter-row">
           <Form.Item
             name="prioridad"
             rules={[{ required: callType !== 'Novedad' ? false : true, message: "requerido" }]}
             label="Prioridad"
           >
             <Select
               showSearch
               size="medium"
               placeholder="Seleccione"
               filterSort={(optionA, optionB) =>
                 (optionA?.label ?? "")
                   .toLowerCase()
                   .localeCompare((optionB?.label ?? "").toLowerCase())
               }
               options={[
                 ...PRIORIDADES.map((p) => {
                   return {
                     value: `${p}`,
                     label: `${p}`,
                   };
                 }),
               ]}
               disabled={callType !== 'Novedad'}
             />
           </Form.Item>
         </Col>
       </Row>
       <h2 className="header-green">Datos Cliente</h2>
       <Row className="form--first-row">
         <Col className="gutter-row">
           <Form.Item
             name="cedulaSubCliente"
             rules={[{ required: false, message: "requerido" }]}
             label="Cedula SubCliente"
           >
             <Input type="text" size="medium" disabled />
           </Form.Item>
         </Col>

         <Col className="gutter-row">
           <Form.Item
             name="nombreSubCliente"
             rules={[{ required: false, message: "requerido" }]}
             label="Nombre SubCliente"
             title={order.nombre}
           >
             <Input type="text" size="medium" disabled />
           </Form.Item>
         </Col>

         <Col className="gutter-row">
           <Form.Item
             name="telefonoPrincipal"
             rules={[{ required: false, message: "requerido" }]}
             label="Telefono Principal"
           >
             <Input type="text" size="medium" disabled />
           </Form.Item>
         </Col>

         <Col className="gutter-row">
           <Form.Item
             name="direccion"
             rules={[{ required: false, message: "requerido" }]}
             label="Direccion SubCliente"
             title={order.direccion}
           >
             <Input type="text" size="medium" disabled />
           </Form.Item>
         </Col>
       </Row>
       <h2 className="header-green">Productos</h2>
       <Row className="form--detail-row">
         <Col className="gutter-row">
           <div className="data-product--table">
             <div className="data-product-table--header">
               <div>Cod. Material</div>
               <div>Material</div>
             </div>
             <div className="data-product-table--body">
               {products.map((p) => (
                 <div>
                   <div>{p.codigoMaterial}</div>
                   <div>{p.material}</div>
                 </div>
               ))}
             </div>
           </div>
         </Col>
       </Row>
       <h2 className="header-green">Detalle</h2>
       <Row className="form--detail-row">
         <Col className="gutter-row">
           <Form.Item
             name="detalle"
             rules={[{ required: true, message: "requerido" }]}
           >
             <TextArea rows={4} showCount />
           </Form.Item>
         </Col>
       </Row>
     </Form>
     )}
    </>
  );
};
